export default __webpack_public_path__ + "static/media/users.bc5a4cb5.svg";